import { useEffect, useState } from "react";
import { CheckCircle2, MonitorDown } from "lucide-react";
import { Card } from "@/components/Kpi";

let promptSalvato = null;
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); promptSalvato = e; });
}

const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

/** Installazione della PWA su PC / telefono: pulsante diretto dove il browser lo consente, istruzioni altrove. */
export function InstallaApp() {
  const [prompt, setPrompt] = useState(promptSalvato);
  const [installata, setInstallata] = useState(isStandalone());

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); promptSalvato = e; setPrompt(e); };
    const onInstalled = () => { setInstallata(true); setPrompt(null); promptSalvato = null; };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => { window.removeEventListener("beforeinstallprompt", onPrompt); window.removeEventListener("appinstalled", onInstalled); };
  }, []);

  const installa = async () => {
    if (!prompt) return;
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === "accepted") { setInstallata(true); setPrompt(null); promptSalvato = null; }
  };

  const ua = navigator.userAgent;
  const isMac = /Macintosh/.test(ua);
  const isIOS = /iPhone|iPad/.test(ua);
  const isEdge = /Edg\//.test(ua);
  const isChrome = /Chrome\//.test(ua) && !isEdge;
  const isSafari = /Safari\//.test(ua) && !/Chrome\//.test(ua);
  const isFirefox = /Firefox\//.test(ua);

  return (
    <Card className="p-6" data-testid="account-installa">
      <h3 className="uppercase text-xs tracking-[0.18em] font-semibold text-slate-500 mb-4">App sul PC / telefono</h3>
      {installata ? (
        <div className="flex items-center gap-2 text-sm text-emerald-700" data-testid="installa-gia-fatta">
          <CheckCircle2 size={16} /> Stai già usando DBE come app installata.
        </div>
      ) : prompt ? (
        <>
          <p className="text-sm text-slate-600 mb-4">
            Installa DBE come applicazione: icona sul desktop, finestra dedicata e notifiche anche con il browser chiuso.
          </p>
          <button type="button" onClick={installa} data-testid="installa-app-btn"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-[#0018A8] text-white text-sm
              hover:bg-[#001480] transition-colors duration-200">
            <MonitorDown size={15} /> Installa sul PC
          </button>
        </>
      ) : (
        <div className="text-sm text-slate-600 space-y-2" data-testid="installa-istruzioni">
          <p>Il browser non offre l'installazione diretta da qui. Procedi così:</p>
          <ul className="list-disc pl-5 space-y-1">
            {isIOS && <li><b>Safari (iPhone/iPad)</b>: tasto Condividi → <i>Aggiungi alla schermata Home</i>.</li>}
            {isChrome && <li><b>Chrome</b>: menu ⋮ → <i>Trasmetti, salva e condividi</i> → <i>Installa pagina come app…</i></li>}
            {isEdge && <li><b>Edge</b>: menu ⋯ → <i>App</i> → <i>Installa questo sito come app</i>.</li>}
            {isSafari && isMac && !isIOS && <li><b>Safari (Mac)</b>: menu <i>File</i> → <i>Aggiungi al Dock</i>.</li>}
            {isFirefox && <li><b>Firefox</b> non supporta l'installazione: apri l'app con Chrome o Edge.</li>}
            {!isIOS && !isChrome && !isEdge && !isSafari && !isFirefox && <li>Apri l'app con Chrome o Edge e usa il menu → <i>Installa</i>.</li>}
          </ul>
          <p className="text-xs text-slate-400">Se l'app risulta già installata, aprila dal desktop o dal menu Start.</p>
        </div>
      )}
    </Card>
  );
}
